import Login from "../Login/Login";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import CaseListing from "../pages/case-study/CaseListing";
import CaseCreate from "../pages/case-study/CaseCreate";
import CaseEdit from "../pages/case-study/CaseEdit";
// import TrackingCode from "../pages/Tracking/TrackingCode";
// import SeoEdit from "../pages/Seo/SeoEdit";
import JobPostingListing from "../pages/jobPosting/JobPostingListing";
import AddJobPosting from "../pages/jobPosting/AddJobPosting";
import Location from "../pages/location/Location";
import Experience from "../pages/experience/Experience";
import Operation from "../pages/operation/operation";
import EditJobPosting from "../pages/jobPosting/EditJobPosting";
// import LocationPageListing from "../pages/locationpage/LocationPageListing";
// import AddLocationPage from "../pages/locationpage/AddLocationPage";
// import EditLocationPage from "../pages/locationpage/EditLocationPage";
// import JobApplications from "../pages/jobApplications/JobApplications";
// import Newsletters from "../pages/newsletters/Newsletters";
import VideoListing from "../pages/videos/VideoListing";
import AddVideo from "../pages/videos/AddVideo";
import EditVideo from "../pages/videos/EditVideo";
import Teams from "../pages/teams/Teams";
import AddTeam from "../pages/teams/AddTeam";
import EditTeam from "../pages/teams/EditTeam";
import EditInfographic from "../pages/infographic/EditInfographic";
import AddInfographic from "../pages/infographic/AddInfographic";
import Infographic from "../pages/infographic/Infographic";
import EditLeadership from "../pages/leadership/EditLeadership";
import AddLeadership from "../pages/leadership/AddLeadership";
import Leadership from "../pages/leadership/Leadership";
import NewsletterPage from "../pages/newsletterPage/NewsletterPage";
import AddNewsletterPage from "../pages/newsletterPage/AddNewsletterPage";
import EditNewsletterPage from "../pages/newsletterPage/EditNewsletterPage";
import PressRelease from "../pages/pressRelease/PressRelease";
import AddPr from "../pages/pressRelease/AddPr";
import EditPr from "../pages/pressRelease/EditPr";
import JobApplications from "../pages/jobApplications/JobApplications";
import SeoEdit from "../pages/Seo/SeoEdit";
import Eguide from "../pages/eguide/Eguide";
import EguideAdd from "../pages/eguide/EguideAdd";
import EguideEdit from "../pages/eguide/EguideEdit";
import Whitepaper from "../pages/whitepaper/Whitepaper";
import WhitepaperAdd from "../pages/whitepaper/WhitepaperAdd";
import WhitepaperEdit from "../pages/whitepaper/WhitepaperEdit";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import LlmsManagement from "../pages/llms-management/LlmsManagement";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";
// import SolutionList from "../pages/solution/SolutionList";
// import SpecialtyList from "../pages/specialty/SpecialtyList";
// import ProviderList from "../pages/provider/ProviderList";



export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />

          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />

          {/* <Route path="solution" element={<SolutionList />} />
          <Route path="specialty" element={<SpecialtyList />} />
          <Route path="provider" element={<ProviderList />} /> */}

          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />

          <Route path="infographic" element={<Infographic />} />
          <Route path="add-infographic" element={<AddInfographic />} />
          <Route path="edit-infographic/:infographic_id" element={<EditInfographic />} />

          <Route path="eguide" element={<Eguide />} />
          <Route path="add-eguide" element={<EguideAdd />} />
          <Route path="edit-eguide/:eguide_id" element={<EguideEdit />} />

          <Route path="whitepaper" element={<Whitepaper />} />
          <Route path="add-whitepaper" element={<WhitepaperAdd />} />
          <Route path="edit-whitepaper/:whitepaper_id" element={<WhitepaperEdit />} />

          <Route path="leadership" element={<Leadership />} />
          <Route path="add-leadership" element={<AddLeadership />} />
          <Route path="edit-leadership/:leadership_id" element={<EditLeadership />} />

          <Route path="video" element={<VideoListing />} />
          <Route path="add-video" element={<AddVideo />} />
          <Route path="edit-video/:video_id" element={<EditVideo />} />

          <Route path="teams" element={<Teams />} />
          <Route path="add-team" element={<AddTeam />} />
          <Route path="edit-team/:team_id" element={<EditTeam />} />

          <Route path="contact" element={<Contact />} />
          {/* <Route path="job-applications" element={<JobApplications />} /> */}
          {/* <Route path="newsletters" element={<Newsletters />} /> */}

          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />
          <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="llms-management" element={<LlmsManagement />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          <Route path="schema-management" element={<SchemaManagement />} />
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
          {/* <Route path="tracking-code" element={<TrackingCode/>} /> */}
          {/* <Route path="case-category" element={<CaseCategory />} /> */}
          <Route path="case" element={<CaseListing />} />
          <Route path="add-case" element={<CaseCreate />} />
          <Route path="edit-case/:case_id" element={<CaseEdit />} />

          <Route path="newsletter-page" element={<NewsletterPage />} />
          <Route path="add-newsletter" element={<AddNewsletterPage />} />
          <Route path="edit-newsletter/:newsletter_id" element={<EditNewsletterPage />} />

          <Route path="press-release" element={<PressRelease />} />
          <Route path="add-press-release" element={<AddPr />} />
          <Route path="edit-press-release/:pressrelease_id" element={<EditPr />} />


           <Route path="jobpost" element={<JobPostingListing />} />
          <Route path="add-jobpost" element={<AddJobPosting />} />
          <Route path="edit-jobpost/:job_id" element={<EditJobPosting />} />

          <Route path="experience" element={<Experience />} />
          <Route path="location" element={<Location />} />
          <Route path="operation" element={<Operation />} />
          <Route path="job-applications" element={<JobApplications />} />

          {/* <Route path="experience" element={<Experience />} />
          <Route path="location" element={<Location />} />
          <Route path="operation" element={<Operation />} /> */}

          {/* <Route path="location-page" element={<LocationPageListing />} />
          <Route path="add-locationpage" element={<AddLocationPage />} />
          <Route path="edit-locationpage/:locpage_id" element={<EditLocationPage />} /> */}


        </Route>
      </Routes>
    </>
  )
}
